import React, { Component } from 'react'
import Page from '../components/Page'
import TrialForm from '../partials/TrialForm'

export default class TrialCustomLabel extends Component {
  render () {
    return (
      <Page size='full'>
        <TrialForm type="customLabel" />
      </Page>
    )
  }
}
